export enum TipoEtapaKanbanEnum {
  FluxoPrincipal = 1,
  Especial = 2,
}
